/**
 * Created by brunopoeta on 12/06/17.
 */

const config = require('../../../../scripts/partials/config');

class EventsController {
    
    constructor($http, $sce, $state, $stateParams, $timeout) {
        this.events = [];

        this.last = true;
        this.page = 1;

        this.months = {
            list: [
                {
                    label: 'Todos',
                    id: null
                }
            ],
            selected: {
                id: null
            }
        };

        this.toolbar = {
            id: 'events-toolbar',
            filters: [
                {
                    callback: this.fetch.bind(this),
                    items: [
                        {
                            id: null,
                            title: 'Todos os temas'
                        }
                    ],
                    label: 'Tema',
                    selected: null
                },
                {
                    callback: this.changeUrl.bind(this),
                    items: [
                        {
                            id: null,
                            title: 'Todos os campus'
                        }
                    ],
                    label: 'Campus',
                    selected: null
                },
                {
                    callback: this.fetch.bind(this),
                    items: [
                        {
                            id: null,
                            name: 'Todos os tipos'
                        }
                    ],
                    label: 'Tipo de evento',
                    selected: null
                }
            ],
            search: {
                callback: this.fetch.bind(this),
                placeholder: 'Digite aqui sua busca',
                query: ''
            }
        };
        this.viewIsReady = false;

        // Services
        this.$http = $http;
        this.$sce = $sce;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;

        // Run functions
        this.getParams();
        this.getMonths();
    }

    changeMonth(month) {
        this
            .months
            .selected = month;

        this.fetch();
    }

    changeUrl() {
        const campus = (this.toolbar.filters[1].selected.id) ? this.toolbar.filters[1].selected.abbv.toLowerCase() : null;

        this.$state.go('.', {campus});
        this.fetch();
    }

    checkFetch() {
        if (this.timeout) {
            this
                .$timeout
                .cancel(this.timeout);
        }

        this.timeout =
            this
                .$timeout(this.fetch, 300);
    }

    convertDate(date) {
        return `${date.day} de ${this.getMonth(date.month)}`;
    }

    convertEvents(events) {
        const converted = [];

        for (let i = 0; i < events.length; i++) {
            let event = events[i];

            event.location = this.$sce.trustAsHtml(event.location);

            converted.push(event);
        }

        return converted;
    }

    convertTime(time) {
        return `${time.start} ${(time.finish) ? ' - ' + time.finish : ''}`;
    }

    fetch(append) {
        if (append) {
            this.page++;
            this.status = 'fetching more';
        } else {
            this.page = 1;
            this.status = 'fetching';
        }

        this
            .$http({
                url: config.events,
                method: 'GET',
                params: {
                    abbv: (!this.toolbar.filters[1].selected) ? this.$stateParams.campus : null,
                    campusId: (this.toolbar.filters[1].selected) ? this.toolbar.filters[1].selected.id : null,
                    month: this.months.selected.id,
                    page: this.page,
                    query: this.toolbar.search.query,
                    themeId: (this.toolbar.filters[0].selected) ? this.toolbar.filters[0].selected.id : null,
                    typeId: (this.toolbar.filters[2].selected) ? this.toolbar.filters[2].selected.id : null,
                    year: this.months.selected.year
                }
            })
            .then((res, err) => {
                if (!err) {
                    if (append) {
                        this.events = this.events.concat(this.convertEvents(res.data.events));
                    } else {
                        this.events = this.convertEvents(res.data.events);
                    }

                    if (this.toolbar.filters[0].items.length === 1) {
                        this.toolbar.filters[0].items = this.toolbar.filters[0].items.concat(res.data.filters.themes);
                    }

                    if (this.toolbar.filters[1].items.length === 1) {
                        this.toolbar.filters[1].items = this.toolbar.filters[1].items.concat(res.data.filters.campi);
                    }

                    if (this.toolbar.filters[2].items.length === 1) {
                        this.toolbar.filters[2].items = this.toolbar.filters[2].items.concat(res.data.filters.types);
                    }

                    this.last = res.data.last;
                    this.status = '';

                    if (!this.viewIsReady) { this.getUrl(); }
                    this.viewIsReady = true;
                } else {
                    console.log(err);
                }
            });
    }

    getMonth(num, abbr) {
        const months = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

        return (abbr) ? months[num - 1].substr(0, 3) : months[num - 1];
    }

    getMonths() {
        const date = new Date();

        for (let i = 1; i < 8; i++) {
            const month = (date.getMonth() + i < 13) ? date.getMonth() + i : ((date.getMonth() + i) % 12 || 1);
            const year = (date.getMonth() + i < 13) ? date.getFullYear() : date.getFullYear() + 1;

            this
                .months
                .list
                .push({
                    id: month,
                    label: this.getMonth(month, true),
                    year: year
                });
        }
    }

    getParams() {
        this.$timeout(() => {
            this.campusAbbr = this.$stateParams.campus;

            this.fetch();
        }, 1);
    }

    getUrl() {
        this.$timeout(() => {
            let selected = null;

            if (this.campusAbbr) {
                this.toolbar.filters[1].items.forEach((campus) => {
                    if (campus.abbv && campus.abbv.toLowerCase() === this.campusAbbr) {
                        selected = campus;
                    }
                });
            }

            this.toolbar.filters[1].selected = selected;
        }, 1);
    }

}

export default EventsController;
